import EfBanner from '@elem/ui/ef-banner';
import { useProductStore } from '@elem/compPage/12v-lithium-battery/ProductProvider';
import { PAGE_TYPE } from '../../constants';
import { IPageStatus } from '../../config/IPageStatus';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.Banner');
    const { pageType, pageStatus } = useProductStore();

    const itemA: any = {
        [PAGE_TYPE.BASE]: {
            theme: 'white',
            title: t('title'),
            desc: t('desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725961544922/pc_kv.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725961553052/m_kv.jpg',
            className: 'base',
        },
        [PAGE_TYPE.MOTOR]: {
            // MOTOR = TM = Trolling Motor
            theme: 'black',
            label: pageStatus == IPageStatus.statusA ? t('label') : '',
            title: t('title'),
            desc: t('desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725590367966/pc_kv.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725592356066/m_kv.jpg',
            className: 'motor',
        },
    };
    return (
        <div className={styles.TheComp}>
            <EfBanner {...itemA[pageType]} />
        </div>
    );
}
